import React, {Component} from 'react';
import { HashRouter, Route, Switch, Redirect} from 'react-router-dom';

import App from "@/views/App";
import Login from "@/views/login";
import register from "@/views/register";
import libraryManageHome from '@/views/home/libraryManageHome' //  博协用户
import provinceManagerHome from '@/views/home/provinceManagerHome' //省级管理员
import professionalHome from '@/views/home/professionalHome'  //专家
import libraryUserHome from '@/views/home/libraryUserHome'  //  博物馆用户
import Err404 from '@/views/404/no'
import { getStorage} from "@/utils";
import MainContent from "@/views/mainContent";
import {message} from "antd";
import {clearboth} from "../utils/clear";
import standardManageRouter from './standardManageRouter'
import standardManageRouterScore from './standardManageRouterScore'
import standardManageRouterCentral from './standardManageRouterCentral'
import standardManageRouterProvince from './standardManageRouterProvince'
const routers = [
  standardManageRouter,
  standardManageRouterScore,
  standardManageRouterCentral,
  standardManageRouterProvince
];

function guards(Cmp){
  return () => {
    const login = sessionStorage.getItem('login')
    if (login) {
      return <Cmp/>
    } else {
      message.error('您还未登录,请先登录系统',2)
      clearboth()
      window.location.href = '/'
    }
  }
}

function guardslogin(Cmp){
  return () => {
    const login = sessionStorage.getItem('login')
    if (login) {
      if (getStorage('userList') === null) {
        clearboth()
        return <Cmp/>
      } else {
        const type = getStorage('userList').clerklevel
        if (type == 8 || type == 9) {
          return <Redirect to="/home" />
        } else if (type == 3 || type == 4 || type == 16) {
          return <Redirect to="/homeCentral" />
        } else if (type == 10 || type == 11) {
          return <Redirect to="/homeScore" />
        } else if (type == 6 || type == 7) {
          return <Redirect to="/homeProvince" />
        }
      }
    } else {
      clearboth()
      return <Cmp/>
    }
  }
}

const renderRoutes = (routers) => {
  return routers.map((item, index)=>{
    if(item.children){
      let Com = item.component;
      return (
          <Com key={index}>
            {renderRoutes(item.children)}
          </Com>
      )
    }else{
      return (
          <Route path={item.path} component={guards(item.component)} exact={item.exact} key={index} />
      )
    }
  })
};
export default class RouteConfig extends Component{
  render(){
    return (
      <HashRouter>
        <Switch>
          <Route exact path="/" component={guardslogin(Login)}  />
          <Route exact path='/login' component={guardslogin(Login)} />
          <Route exact path='/register' component={register} />
          <App>
            <MainContent>
              <Route exact path='/home' component={guards(libraryUserHome)} />
              <Route exact path='/homeCentral' component={guards(libraryManageHome)} />
              <Route exact path='/homeProvince' component={guards(provinceManagerHome)} />
              <Route exact path='/homeScore' component={guards(professionalHome)} />
              {renderRoutes(routers)}
            </MainContent>
          </App>
          <Route path="/error" component={Err404}/>
          <Route path="*" render={()=><Redirect to='/error'/>}/>
        </Switch>
      </HashRouter>
    )
  }
}
